module.exports = __webpack_public_path__ + "images/stickers/pete-music.49ddddf5af19ae49ccc9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-music.png
// module id = looG
// module chunks = 1